import axiosLib from "axios";
import { EVA_LOGIN } from "helpers/urlHelper";
const axios = axiosLib.create({
  withCredentials: true, // 
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.warn("⛔ Token expired or invalid!");
      window.location.href = EVA_LOGIN; 
    }

    return Promise.reject(error);
  }
);

export default axios;